import React, { useCallback, useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { v1 as uuid } from 'uuid';

import Switch from '@xcritical/switch';
import {
  xcriticalFiltersAdd,
  xcriticalFiltersChangeFilter,
  filterSelector,
} from '@xcritical/filter';

import { Label } from '@crm-framework/label';
import { useGrid } from '@crm-framework/grid';

import { WrapperItem } from '../styles';

export const ISDEMO_FIELD_NAME = 'isDemo';

// eslint-disable-next-line import/no-mutable-exports
let ISDEMO_FIELD_KEY = uuid();

export interface IDemoTogglerProps {
  dashboardName: string;
}

export const DemoToggler: React.FC<IDemoTogglerProps> = ({ dashboardName }) => {
  const { filters } = useGrid(dashboardName);

  const { drafts } = useSelector((state) =>
    filterSelector(state, dashboardName)
  );
  const [checked, setChecked] = useState(false);
  const dispatch = useDispatch();
  const isDemoFilterEnabled = filters.find(
    ({ field }) => field === ISDEMO_FIELD_NAME
  );

  const onChange = useCallback((_checked: boolean) => {
    setChecked(_checked);
    dispatch(
      xcriticalFiltersChangeFilter(dashboardName, {
        field: 'value',
        guid: ISDEMO_FIELD_KEY,
        value: (_checked ? 1 : 0) as any, // TODO: need change type in @xcritical/filter
      })
    );
  }, []);

  useEffect(() => {
    const filterAdded = drafts.find((f) => f.column === ISDEMO_FIELD_NAME);

    if (!filterAdded && isDemoFilterEnabled) {
      dispatch(
        xcriticalFiltersAdd(dashboardName, {
          column: ISDEMO_FIELD_NAME,
          condition: 'equalsTo',
          value: 0,
          key: ISDEMO_FIELD_KEY,
        })
      );
    } else if (filterAdded) {
      if (ISDEMO_FIELD_KEY !== filterAdded.key) {
        ISDEMO_FIELD_KEY = filterAdded.key;
        setChecked(false);
      }
    }
  }, [drafts, isDemoFilterEnabled]);

  if (!isDemoFilterEnabled) return null;

  return (
    <WrapperItem>
      <Label htmlFor="DemoFilterSwitcher">Real</Label>
      <Switch
        name="DemoFilterSwitcher"
        label="Demo"
        onChange={onChange}
        checked={checked}
      />
    </WrapperItem>
  );
};
